var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStaking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6665 6.6665C31.6665 7.8875 31.315 9.0155 30.742 10H40V16.6665H0V10H9.258C8.686 9.015 8.3335 7.887 8.3335 6.6665C8.3335 2.985 11.3185 0 15 0C17.0025 0 18.7775 0.902 20 2.3C21.222 0.9015 22.998 0 25 0C28.6815 0 31.6665 2.985 31.6665 6.6665ZM25 3.333C23.1625 3.333 21.6665 4.827 21.6665 6.6665V10H25C26.8375 10 28.3335 8.504 28.3335 6.6665C28.3335 4.827 26.8375 3.333 25 3.333ZM11.6665 6.6665C11.6665 4.827 13.162 3.333 15 3.333C16.838 3.333 18.3335 4.827 18.3335 6.6665V10H15C13.1625 10 11.6665 8.504 11.6665 6.6665ZM18.3335 30.773C16.5635 32.362 14.232 33.335 11.6675 33.335V30.0015C15.3435 30.0015 18.327 27.0215 18.3335 23.345V23.334V20H3.3335V40H18.3335V30.773ZM21.6665 20V23.3335C21.6665 27.013 24.652 30 28.3335 30V33.3335C25.768 33.3335 23.4375 32.36 21.6665 30.7715V40H36.6665V20H21.6665Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21C1E0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.1d9069dfa09f99c6a5c901d8a6fc10fd.svg";
export { ForwardRef as ReactComponent };